import { render, staticRenderFns } from "./TablePerformance.vue?vue&type=template&id=b827564c&"
import script from "./TablePerformance.vue?vue&type=script&lang=js&"
export * from "./TablePerformance.vue?vue&type=script&lang=js&"
import style0 from "./TablePerformance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports